import React, { useState } from 'react';
import Sacred from './img/Mockup_Sacred.png'
import Infinite from './img/Mockup_Infinite.png'
import Placeholder from './img/Mockup_Placeholder.png'


function Products({onAdd}) {

    const [products] = useState([
        {
            id: '1',
            name: '"Sacred Geometry" Vinyl',
            cost: 10,
            image: Sacred,
        },
        {
            id: '2',
            name: '"Classic Tracks" Vinyl',
            cost: 30,
            image: Infinite,
        },
        {
            id: '3',
            name: 'First EP(Name TBD) Pre Order',
            cost: 10,
            image: Placeholder,
        },
    ]);


    
  return <>
            <h2>Albums/Vinyls/Merch</h2>
            <div className="products">
            {products.map((product, idx) => ( <div className="product" key={idx}>
                <h3>{product.name}</h3>
                <h4>${product.cost.toFixed(2)}</h4>
                <img src={product.image}/><br/>
                <button onClick={() => onAdd(product)}>Add To Cart</button>
                
            </div>))}
            </div>
        </>
;
}

export default Products;
